import { auditReports } from '@mi-front/api-clients';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  run: auditReports.AodRun;
}

export function ReprocessCompletion({ run }: Props) {
  const { $t } = useIntl();

  if (!run.isReprocessCompleted) {
    return null;
  }

  return (
    <Box>
      <CheckCircleIcon />{' '}
      {$t({
        id: 'audit.aod.actions.triggerReprocess.completed',
        defaultMessage: 'Reprocesamiento completado',
      })}
    </Box>
  );
}
